export const rotuloSelectStyles = () => ({
  control: (provided) => ({
      ...provided,
      width: 400,
      //height: "10px",
      //minHeight: "10px",
      transition: 'width 0.3s ease',
      fontWeight: 600, // Semibold
      backgroundColor: '#d3d3d3'
  }),
  menu: (provided) => ({
      ...provided,
      width: 400,
      fontWeight: 600, // Semibold
      backgroundColor: '#d3d3d3', // Gris claro
      color: 'black' // Letra negra
  }),
  singleValue: (provided) => ({
      ...provided,
      fontWeight: 600 // Semibold
  }),
  option: (provided) => ({
      ...provided,
      fontWeight: 600 // Semibold
  })
});